export class PartnerLoadOptions {

    constructor(defaultValue = true) {       
        this.LoadPartnerAgreement = defaultValue;
        this.LoadPartnerAttachments = defaultValue;
        this.LoadEdiConfig = defaultValue;
        this.LoadX12Config = defaultValue;
        this.LoadMainIdentification = defaultValue;
        this.LoadPartnerDefaultLocation = defaultValue;
        this.LoadPartnerLocations = defaultValue;
        this.LoadFtpConfig = defaultValue;
    }

    LoadPartnerAgreement: boolean;
    LoadPartnerAttachments: boolean;
    LoadEdiConfig: boolean;
    LoadX12Config: boolean;
    LoadMainIdentification: boolean;
    LoadPartnerDefaultLocation: boolean;
    LoadPartnerLocations: boolean;
    LoadFtpConfig: boolean;

    UseCache: boolean;
    IncludeDeleted: boolean;
}
